import { NEWS_URL } from '@constants';
import { formatTag } from '../../../utils/formatTag';
import { Link } from 'react-router';

export type TagListProps = {
  tags: string[];
};

function TagList({ tags }: TagListProps) {
  return (
    <ul className="tag-list">
      {tags.map((tag) => (
        <li className="tag-list__list-item" key={tag}>
          <Link to={`${NEWS_URL}?tags=${tag}`} className="tag-list__tag">
            {formatTag(tag)}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default TagList;
